// extracted by mini-css-extract-plugin
module.exports = {"title":"CartEmpty_title__7remY","subtitle":"CartEmpty_subtitle__WwF8C","useFade-fadeIn":"CartEmpty_useFade-fadeIn__9TvrX","useFade-fadeOut":"CartEmpty_useFade-fadeOut__RtMNK"};